import script from "./AggreMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AggreMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AggreMenu.vue?vue&type=style&index=0&id=1075ef4d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1075ef4d"]])

export default __exports__